import { Injectable } from '@angular/core';
import { Template } from './template';
import { TEMPLATES } from './mock-templates';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../auth/auth.service';
import {FolderContainer} from "../../storyboard/shared/FolderContainer";
import {Folder} from "storyboard-renderer";

@Injectable()
export class TemplateService {

  templates: Template[] = [];

  private endpoint = environment.apiBaseUrl + '/api/v1.0/';
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: Http, private authService: AuthService) {

  }

  getTemplates(): Promise<Template[]> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template';

    return this.http.get(url)
        .toPromise()
        .then(response => response.json().data as Template[])
        .catch(this.handleError);
  }

  getTemplate(id: number): Promise<Template> {
    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template/' + id;

    return this.http.get(url)
        .toPromise()
        .then(response => {
          return Template.fromJson(response.json())
        })
        .catch(this.handleError);
  }

  getFolders(): Promise<Folder[]> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder';

    return this.http.get(url)
        .toPromise()
        .then(response => response.json().data as Folder[])
        .catch(this.handleError);
  }

  updateTitle(id: number, title: string): Promise<Template> {
    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template/' + id;

    return this.http
        .put(url, {title: title}, {headers: this.headers})
        .toPromise()
        .catch(this.handleError);
  }

  update(template: Template): Promise<Template> {
    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template/' + template.id;

    return this.http
        .put(url, JSON.stringify(template), {headers: this.headers})
        .toPromise()
        .then(() => template)
        .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getTemplatesInFolderedStructure(): Promise<FolderContainer> {

    const folderContainer: FolderContainer = new FolderContainer();

    return this.getFolders().then(
        folders => {

          for (let i = 0; i < folders.length; i++) {

            /*if (folders[i].folder != null) {// list only root folders
              continue;
            }*/

            // Collapse the folder if its empty
            folders[i].collapsed = folders[i].items.length === 0;

            folderContainer.folders.push(folders[i]);
          }

          return folderContainer;
        }
    );

  }

  delete(template: Template): Promise<Template[]> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template/' + template.id;

    return this.http
        .delete(url, {headers: this.headers})
        .toPromise()
        .catch(this.handleError);
  }

  create(storyboard: Template): Promise<Template> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template';

    return this.http
        .post(url, JSON.stringify(storyboard), {headers: this.headers})
        .toPromise()
        .then(response => Template.fromJson(response.json()))
        .catch(this.handleError);

  }

  deleteFolder(folder: Folder): Promise<void> {
    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder/' + folder.id;
    return this.http
        .delete(url, {headers: this.headers})
        .toPromise()
        .catch(this.handleError);
  }

  createFolder(folder: Folder): Promise<Folder> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder';

    return this.http
        .post(url, folder, {headers: this.headers})
        .toPromise()
        .then(response => Folder.fromJson(response.json()))
        .catch(this.handleError);
  }

  updateFolder(folder: Folder): Promise<Folder> {
    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder/' + folder.id;

    return this.http
        .put(url, folder, {headers: this.headers})
        .toPromise()
        .catch(this.handleError);
  }

  getFolder(query: Object): Promise<Folder> {
    let self = this;
    return new Promise(function(resolve, reject){

      self.getFolders().then(folders => {

        folders.forEach(item => {
          if (query && query['title']){
            if (item.title === query['title']){
              return resolve(item);
            }
          }
        });
        return reject("no folder found for query");
      });

    });
  }

  folderFirstOrCreate(query: Object): Promise<Folder> {
    let self = this;
    return new Promise(function(resolve, reject){
      self.getFolder(query)
          .then(resolve)
          .catch(err => {
            self.createFolder(new Folder(null, query['title']))
                .then(resolve)
                .catch(reject);
          })
    });
  }

  private getRelatedFolder(folder: Folder, folders: Folder[]): Folder {
    for (let i = 0; i < folders.length; i++) {
      if (folders[i].id === folder.id) {
        return folders[i];
      }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/template/shared/template.service.ts